import { gestorInstance } from "@/plugins/axios";

const livekitService = {};

livekitService.generateToken = (data) => {
  return gestorInstance.post(`/livekit/token`, data);
};

livekitService.kickParticipant = (data) => {
  return gestorInstance.post(`/livekit/kick`, data);
};

livekitService.muteParticipant = (data) => {
  return gestorInstance.post(`/livekit/mute-participant`, data);
};

livekitService.admitParticipant = (data) => {
  return gestorInstance.post(`/livekit/admit`, data);
};

livekitService.startRecording = (data) => {
  return gestorInstance.post(`/livekit/start-recording`, data);
};

livekitService.stopRecording = (data) => {
  return gestorInstance.post(`/livekit/stop-recording`, data);
};

livekitService.getRoomStatus = (roomName) => {
  return gestorInstance.get(`/livekit/room/${roomName}/status`);
};

livekitService.listRooms = () => {
  return gestorInstance.get(`/livekit/rooms`);
};

livekitService.deleteRoom = (roomName) => {
  return gestorInstance.delete(`/livekit/room/${roomName}`);
};

// ============================================================
// Levantar la mano (self-service, cualquier participante)
// ============================================================

livekitService.raiseHand = (data) => {
  // { roomName, identity, raised }
  return gestorInstance.post(`/livekit/raise-hand`, data);
};

// ============================================================
// Networking: moderación autorizada por JWT legacy (sin moderatorKey)
// ============================================================

livekitService.networkingMuteParticipant = (data) => {
  // { mainRoom, roomName?, identity, muted, source }
  return gestorInstance.post(`/livekit/networking/mute`, data);
};

livekitService.networkingKickParticipant = (data) => {
  // { mainRoom, roomName?, identity }
  return gestorInstance.post(`/livekit/networking/kick`, data);
};

livekitService.networkingMuteAll = (data) => {
  // { mainRoom, roomName?, includeCamera? }
  return gestorInstance.post(`/livekit/networking/mute-all`, data);
};

livekitService.networkingGrantPublish = (data) => {
  // { mainRoom, roomName?, identity, allow, sources? }
  return gestorInstance.post(`/livekit/networking/grant-publish`, data);
};

livekitService.networkingStartRecording = (data) => {
  // { mainRoom, roomName? }
  return gestorInstance.post(`/livekit/networking/start-recording`, data);
};

livekitService.networkingStopRecording = (data) => {
  // { mainRoom, roomName? }
  return gestorInstance.post(`/livekit/networking/stop-recording`, data);
};

livekitService.networkingOccupancy = (mainRoom, { silent } = {}) => {
  // { mainRoom, count, capacity, isFull, alreadyInside }
  return gestorInstance.get(`/livekit/networking/occupancy`, {
    params: { mainRoom },
    silent: Boolean(silent),
  });
};

// ============================================================
// Networking: breakout rooms (sub-salas)
// ============================================================

livekitService.generateBreakoutToken = (data) => {
  // { mainRoom, targetRoom, participantName, participantIdentity, metadata }
  return gestorInstance.post(`/livekit/networking/breakout/token`, data);
};

livekitService.moveToBreakout = (data) => {
  // { mainRoom, moves: [{ userId, targetRoom }] }
  return gestorInstance.post(`/livekit/networking/breakout/move`, data);
};

livekitService.returnFromBreakout = (data) => {
  // { mainRoom, userIds? }
  return gestorInstance.post(`/livekit/networking/breakout/return`, data);
};

livekitService.broadcastToBreakouts = (data) => {
  // { mainRoom, message }
  return gestorInstance.post(`/livekit/networking/breakout/broadcast`, data);
};

livekitService.closeBreakoutRooms = (data) => {
  // { mainRoom, seconds }
  return gestorInstance.post(`/livekit/networking/breakout/close`, data);
};

export default livekitService;
